module.exports = __webpack_public_path__ + "static/media/gallery-4-2.dd29c66b.png";